import { Alignment } from '../../alignment';
import { WidgetType } from './widgetType';
export var PdfViewMode;
(function (PdfViewMode) {
    PdfViewMode[PdfViewMode["InNewWindow"] = 0] = "InNewWindow";
    PdfViewMode[PdfViewMode["Preview"] = 1] = "Preview";
})(PdfViewMode || (PdfViewMode = {}));
export const PDFWidgetHelper = {
    isPdfWidget: (widget) => {
        return widget.value.type === WidgetType.pdf;
    },
    makeDefaultProperties: () => ({
        // caption: '', //why it is not being used, but it is required
        // page: 0, //why it is not being used, but it is required
        alignment: Alignment.center,
        mode: PdfViewMode.Preview,
        allowDownload: true,
        displayDelayInSeconds: 0,
    }), //i must hack return type
};
